export const SUBSCRIPTION_TIERS = {
    SELF_SERVICE: 'QSRNDHPfV',
    TRIAL: 'trial'
};
const isSelfServiceTier = (subscriptionTier) => {
    return subscriptionTier === SUBSCRIPTION_TIERS.SELF_SERVICE;
};
export const isSelfServiceAccount = (account) => {
    return (!!account.stripeCustomerId && isSelfServiceTier(account.subscriptionTier));
};
